import { Spinner as OfficeSpinner } from '@fluentui/react';

export const UpdateContent = styled.div`
    margin-top: 1.5rem;
    overflow-wrap: break-word; /* Break long words */
    word-break: break-word; /* Prevent long words from overflowing */
    width: 100%;
`;

export const TaskRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: auto; /* Allow height to adjust based on content */
    margin-bottom: 1rem;
    flex-wrap: wrap; /* Ensure wrapping for small screens */
    width: 100%;
`;

export const StatusText = styled.p`
    margin: 0;
    margin-left: auto;
    text-align: right;
    padding-left: 1rem;
    white-space: normal; /* Allow text to wrap */
    overflow-wrap: break-word; /* Prevent text from overflowing */
    word-break: break-word; /* Break long words if needed */
    width: auto; /* Allow width to adjust based on content */
    max-width: 100%; /* Make sure it takes available space */
    word-wrap: break-word; /* Prevent long words from breaking layout */
`;

export const Spinner = styled(OfficeSpinner)<any>`
    & > .ms-Spinner-circle {
        border-width: 3px;
        height: ${props => props.size}px;
        width: ${props => props.size}px;
    }
`
export const LowerContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center; /* Ensure the button stays centered */
    align-items: center; /* Ensure elements stay centered */
    flex-wrap: wrap;
`;

export const WarningText = styled.p`
    margin: 10px 0;    
    color: grey;
    font-size: 14px;
    text-align: center;
    line-height: 16px;
`;